import { render, staticRenderFns } from "./ClientPortfolio.vue?vue&type=template&id=28bd7df0&"
import script from "./ClientPortfolio.vue?vue&type=script&lang=js&"
export * from "./ClientPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports